import { environment } from './environments/environment';

export const CONSTANTS = {
  authConfig: {
    authUrl: environment.authUrl,
    parameters: {
      client_id: environment.clientId,
      resource: environment.resource,
      response_type: environment.responseType
    }
  },

  apiConfig: {
    activateAPI: true,
    apiUrl: environment.backendApiUrl,
    apiUrlPostfix_get: `/get?url=${environment.dynamicsUrl}`,
    apiUrlPostfix_patch: `/patch?url=${environment.dynamicsUrl}`,
    apiUrlPostfix_post: `/post?url=${environment.dynamicsUrl}`,
    apiUrlPostfix_delete: `/delete?url=${environment.dynamicsUrl}`,
    dynamicsUrl: environment.dynamicsUrl
  }
};